export const CLOCK_TYPES = {
  ANALOG: 'analog',
  DIGITAL: 'digital'
};

export const CLOCK_TYPES_LIST = [CLOCK_TYPES.ANALOG, CLOCK_TYPES.DIGITAL];
